module.exports = __webpack_public_path__ + "static/img/img5.44a0740.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/content/product/images/img5.png
// module id = QG3U
// module chunks = 1